import { DatepickerSingleProps } from '../Datepicker.consts';
import { DatepickerSingleFooter } from './Footer/DatepickerSingleFooter';
import { DatepickerSingleGrid } from './Grid/DatepickerSingleGrid';
import { DatepickerSingleHeader } from './Header/DatepickerSignleHeader';

export const DatepickerSingle: React.FC<DatepickerSingleProps> = ({
  presetDate,
  onSingleDateSelect,
}: DatepickerSingleProps) => {
  return (
    <>
      <DatepickerSingleHeader />
      <DatepickerSingleGrid presetDate={presetDate} />
      <DatepickerSingleFooter onSingleDateSelect={onSingleDateSelect} />
    </>
  );
};
